import { render, staticRenderFns } from "./SelectingValuesDefault.vue?vue&type=template&id=483c85ce"
import script from "./SelectingValuesDefault.vue?vue&type=script&lang=js"
export * from "./SelectingValuesDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports